export default __webpack_public_path__ + "static/media/MKM English_00.782d6ab7.png";